export const SIGNIN = "SIGNIN";
export const AUTHENTICATED = "AUTHENTICATED";
export const SIGNOUT = "SIGNOUT";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SHOW_AUTH_MESSAGE = "SHOW_AUTH_MESSAGE";
export const HIDE_AUTH_MESSAGE = "HIDE_AUTH_MESSAGE";
export const SHOW_LOADING = "SHOW_LOADING";
export const AUTH_TOKEN = "auth_token";
export const SIGNIN_WITH_GOOGLE = "SIGNIN_WITH_GOOGLE";
export const SIGNIN_WITH_GOOGLE_AUTHENTICATED =
  "SIGNIN_WITH_GOOGLE_AUTHENTICATED";
export const SIGNIN_WITH_FACEBOOK = "SIGNIN_WITH_FACEBOOK";
export const SIGNIN_WITH_FACEBOOK_AUTHENTICATED =
  "SIGNIN_WITH_FACEBOOK_AUTHENTICATED";
export const SIGNIN_WITH_COGNITO = "SIGNIN_WITH_COGNITO";
export const SIGNIN_WITH_COGNITO_AUTHENTICATED =
  "SIGNIN_WITH_COGNITO_AUTHENTICATED";
export const SIGNIN_WITH_EMAIL = "SIGNIN_WITH_EMAIL";
export const SIGNIN_WITH_EMAIL_SUCCESS = "SIGNIN_WITH_EMAIL_SUCCESS";
export const SIGNIN_WITH_EMAIL_FALSE = "SIGNIN_WITH_EMAIL_FALSE";
export const REQUIRED_NEW_PASSWORD = "REQUIRED_NEW_PASSWORD";
export const INPUT_NEW_PASSWORD = "INPUT_NEW_PASSWORD";
export const SIGNIN_EMAIL_AUTHENTICATED = "SIGNIN_EMAIL_AUTHENTICATED";
